export enum ActionType {
    GUEST_CONFIRM_ASSISTANCE = "guest_confirm_assistance"
}

export interface ConfirmActionCodePayload {
    actionType: ActionType
    externalCode: string
}
